import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { getActiveBatchId } from '../api/importService';
/**
 * Hook for fetching the currently active import batch ID.
 * Returns null when no import is in progress.
 * Active-batch lookup is cheap and only used to gate one button; refetch on
 * window focus is enough — no need for polling.
 */
var useActiveImportBatch = function () {
    var ky = useOkapiKy();
    return useQuery(['czna-import-active'], function () { return getActiveBatchId(ky); }, {
        refetchOnWindowFocus: true,
    });
};
export default useActiveImportBatch;
